export default () => {
  document.querySelectorAll('a[href^="http"]').forEach(function (el) {
    let href = el.getAttribute('href');
    if (!href.match(/placetel/) && !href.match(/javascript:/) && (new URL(href).host !== window.location.host || href.match(/pdf$/) || href.match(/popup=1/))) {
      el.setAttribute('target', '_blank');
    }
  });
}